import Decimal from "decimal.js";

import { Currencies } from "../currencies/types";

export function useFormatMoneyValue(currency: string | null | undefined) {
	const c = Currencies[currency?.toUpperCase() || "USD"]!;

	return {
		to: (value: number | undefined | null) => {
			if (value === undefined || value === null) {
				return null;
			}

			const decimalPlaces = c.decimalPlaces || 2;
			const majorUnitValue = new Decimal(value || 0).dividedBy(
				Decimal.pow(10, decimalPlaces),
			);
			return majorUnitValue.toNumber();
		},
		from: (value: string) => {
			if (!value || value.trim() === "") {
				return 0;
			}

			// Handle edge cases for decimal input
			let cleanValue = value.trim();
			if (cleanValue === ".") {
				return 0;
			}

			// Remove trailing decimal point for processing
			if (cleanValue.endsWith(".")) {
				cleanValue = cleanValue.slice(0, -1);
				if (cleanValue === "") {
					return 0;
				}
			}

			const decimalPlaces = c.decimalPlaces;

			try {
				const numericValue = new Decimal(cleanValue);
				return numericValue.times(Decimal.pow(10, decimalPlaces)).toNumber();
			} catch {
				// If parsing fails, return 0
				return 0;
			}
		},
		currency: c,
	};
}
